import * as yup from 'yup'

const schema = yup.object().shape({
  sectionName: yup.string().required(),
  sectionResponsibleName: yup.string().required(),
  email: yup.string().required(),
  phone: yup.string().required(),
  phone2: yup.string(),
})

export default schema
